import { render, staticRenderFns } from "./XsellProducts.vue?vue&type=template&id=41ac180e&scoped=true&lang=pug&"
import script from "./XsellProducts.vue?vue&type=script&lang=js&"
export * from "./XsellProducts.vue?vue&type=script&lang=js&"
import style0 from "./XsellProducts.vue?vue&type=style&index=0&id=41ac180e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ac180e",
  null
  
)

export default component.exports